import React from "react";
import { useState } from "react";
// import "./DiscussForm.css"; // Optional: your custom styles

const DiscussForm = () => {

    const [formData, setFormData] = useState({
        name: "",
        mobile: "",
        email: "",
        message: "",
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await fetch(
                "https://peracause.com/backend-files/tattva/contact-tattva.php",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: new URLSearchParams(formData).toString(),
                }
            );

            const result = await response.json();
            alert(result.message);

            if (result.status === "success") {
                setFormData({ name: "", mobile: "", email: "", message: "" });
            }
        } catch (error) {
            alert("There was an error submitting the form.");
        }

        setLoading(false);
    };

    return (
        <div className='container-fluid py-5 home-discuss'>
            <div className='container py-5 home-discuss-inner bg-light p-4 rounded-15 shadow-sm'>
                <h1 className='syne-title mb-4 text-start'>
                    LET'S DISCUSS<br />YOUR IDEA<span className='text-rose'>.</span>
                </h1>
                <div className='discuss-inner'>
                    <div className='row align-items-center'>
                        <div className='col-lg-6'>
                            <div className='discuss-left text-start'>
                                <p className='text-secondary'>
                                    We’re excited to hear your vision! Whether you have a concept or need help brainstorming, our team is ready to collaborate. Let’s connect and turn your idea into reality—schedule a meeting with us today!
                                </p>
                                <div className='discuss-mail d-flex align-items-center my-3'>
                                    <i className='fas fa-envelope me-2'></i>
                                    <p className='mb-0 text-secondary'>rakesh.tattvahilife@gmail.com</p>
                                </div>
                                <div className='discuss-mail d-flex align-items-center my-3'>
                                    <i className='fas fa-mobile-alt me-2'></i>
                                    <p className='mb-0 text-secondary'>+91 88970 35800</p>
                                </div>
                                <div className='discuss-mail d-flex align-items-center my-3'>
                                    <i className='fas fa-map-marker-alt me-2'></i>
                                    <p className='mb-0 text-secondary'>10, Prashanthi Hills, Khajaguda, Gachibowli, Hyderabad</p>
                                </div>
                                <div className='discuss-icons d-flex'>
                                    <a href='https://www.linkedin.com/in/tattva-hi-life-735094319/' target='_blank' rel="noreferrer" className='text-decoration-none'>
                                        <i className='fab fa-linkedin-in text-white'></i>
                                    </a>
                                    <a href='https://x.com/TattvaHiLife' target='_blank' rel="noreferrer" className='text-decoration-none'>
                                        <i className='fab fa-twitter text-white'></i>
                                    </a>
                                    <a href='https://www.facebook.com/profile.php?id=100086552704523' target='_blank' rel="noreferrer" className='text-decoration-none'>
                                        <i className='fab fa-facebook-f text-white'></i>
                                    </a>
                                    <a href='https://www.instagram.com/tattvahilife_international/' target='_blank' rel="noreferrer" className='text-decoration-none'>
                                        <i className='fab fa-instagram text-white'></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <form onSubmit={handleSubmit}>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    placeholder="Name"
                                    onChange={handleChange}
                                    className="form-control my-2"
                                    required
                                />
                                <input
                                    type="text"
                                    name="mobile"
                                    value={formData.mobile}
                                    placeholder="Mobile"
                                    onChange={handleChange}
                                    className="form-control my-2"
                                    required
                                />
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    placeholder="Email"
                                    onChange={handleChange}
                                    className="form-control my-2"
                                    required
                                />
                                <textarea
                                    name="message"
                                    value={formData.message}
                                    placeholder="Message"
                                    rows="4"
                                    onChange={handleChange}
                                    className="form-control my-2"
                                    required
                                ></textarea>

                                <div className="text-start mt-3 d-flex align-items-center">
                                    <span className="fs-2 text-rose">→</span>
                                    <button
                                        type="submit"
                                        className="border-0 text-rose discuss-btn"
                                        disabled={loading}
                                    >
                                        {loading ? "Sending..." : "Send"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DiscussForm;
